var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xlmns: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.667 5.625c-0.92053 0-1.6667 0.79282-1.6667 1.7708s0.74613 1.7708 1.6667 1.7708c0.92053 0 1.6667-0.79282 1.6667-1.7708s-0.74613-1.7708-1.6667-1.7708zm-3.5287 0.70833c0.43533-1.6352 1.8503-2.8333 3.5287-2.8333s3.0933 1.1981 3.5287 2.8333h1.8047c0.55227 0 1 0.4757 1 1.0625s-0.44773 1.0625-1 1.0625h-1.8047c-0.43533 1.6353-1.8503 2.8333-3.5287 2.8333s-3.0933-1.1981-3.5287-2.8333h-7.138c-0.55228 0-1-0.4757-1-1.0625s0.44772-1.0625 1-1.0625zm-1.8047 8.5c-0.92048 0-1.6667 0.79277-1.6667 1.7708 0 0.97807 0.74619 1.7708 1.6667 1.7708 0.92053 0 1.6667-0.79277 1.6667-1.7708 0-0.97807-0.74613-1.7708-1.6667-1.7708zm-3.5286 0.70833c0.43528-1.6353 1.8503-2.8333 3.5286-2.8333 1.6784 0 3.0933 1.1981 3.5287 2.8333h7.138c0.55227 0 1 0.47572 1 1.0625 0 0.58678-0.44773 1.0625-1 1.0625h-7.138c-0.43533 1.6353-1.8503 2.8333-3.5287 2.8333-1.6784 0-3.0934-1.1981-3.5286-2.8333h-1.8047c-0.55228 0-1-0.47572-1-1.0625 0-0.58678 0.44772-1.0625 1-1.0625z",
    clipRule: "evenodd",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.61135105ccc07c36d08c60125e111af0.svg";
export { ForwardRef as ReactComponent };